<template>
  <div class="row w-100 m-0">
    <div class="col-2 px-1 flex-center">
      <i :class="icon" class="fas fa-lg text-primary"></i>
    </div>
    <div class="col-10 p-0 pl-2 d-block lh-small text-size-small d-flex align-items-center">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'icon': String
  }
}
</script>
